export const ROUTER_TREE = {
  HOMEPAGE: 'homepage',
  COMPARE: 'compare',
  INSTITUTIONS: 'institutions',
  INSTITUTION: 'institution',
  DATA_SOURCES: 'data-sources',
  PRIVACY_POLICY: 'privacy-policy'
};
